import {Formik} from 'formik';

import {FormComponent} from './FormComponent';

import {RecordSchema} from './RecordSchema';
import {toFormikValidationSchema} from 'zod-formik-adapter';

import {FormWithButtons} from '@flexinet/ui-components';

import {Order} from '../types';
import {useParams} from "react-router-dom";
import {stage} from "../../../config/stage";

export const RecordForm = ({
                               record,
                               handleSubmit,
                               handleCancel,
                           }: {
    record: Partial<Order>,
    handleSubmit: (values: Order) => Promise<unknown>,
    handleCancel?: () => void
}) => {
    const {id: customerId} = useParams();

    // Returning the promise is what keeps Formik's isSubmitting true (and Save disabled)
    // until the save settles; a fire-and-forget call drops it immediately (§6).
    const onSubmit = (values: Order) => handleSubmit(values);

    const onCancel = () => {
        handleCancel?.();
    };


    let initialValues = {customerId: customerId} as Order;

    if (record) {
        initialValues = Object.assign({}, initialValues, record);
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={toFormikValidationSchema(RecordSchema)}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={onCancel} debug={false && stage === 'ide'} {...rest}  >
                    <FormComponent/>
                </FormWithButtons>)}
        </Formik>
    );
};
